import React from "react";
import { Link } from "react-router-dom";

const EditButton = ({ to, id, page, search }) => {
  return (
    <Link
      className="dropdown-item text-edit"
      to={`${to}?id=${id}${page ? `&page=${page}` : ""}${
        search ? `&search=${search}` : ""
      }`}
    >
      <img
        src="/assets/images/kidskart/icon/compose.png"
        className="me-2"
        alt="Edit"
      />
      Edit
    </Link>
  );
};

export default EditButton;
